const accordion = {};
accordion.toggleBtns = Array.from(
	document.querySelectorAll('.accordion-toggle')
);
accordion.accordions = Array.from(document.querySelectorAll('.accordion'));

/**
 * Toggle the accordions
 */
accordion.toggleAccord = function(button) {
	let accord = button.parentNode.parentNode; // Get accordion
	let body = button.parentNode.parentNode.nextElementSibling; // Get body content
	let bodyClass = body.className;
	let bodyClassActive = bodyClass.indexOf('active') !== -1;

	if (!bodyClassActive) {
		button.classList.add('open');
		button.setAttribute('aria-expanded', 'true');

		body.classList.add('active');
		body.style.height = 'auto';
		accord.classList.add('active');
		let height;
		if (body.className.indexOf('accordion-body-container') !== -1) {
			height = body.clientHeight + 'px';
		} else {
			height = '310px';
			button.querySelector('span').textContent = 'Hide Transcript';
		}

		body.style.height = '0px';
		body.setAttribute('aria-hidden', 'false');

		setTimeout(function() {
			body.style.height = height;
		}, 0);
		return;
	} else {
		button.classList.remove('open');
		button.setAttribute('aria-expanded', 'false');
		if (!(body.className.indexOf('accordion-body-container') !== -1)) {
			button.querySelector('span').textContent = 'Show Transcript';
		}

		body.style.height = '0px';

		body.addEventListener('transitionend', function accordionTransition() {
			body.classList.remove('active');
			body.setAttribute('aria-hidden', 'true');
			accord.classList.remove('active');
			body.removeEventListener('transitionend', accordionTransition);
			return;
		});
	}
};

// Event Listeners
if (accordion.toggleBtns.length) {
	//listen on whole button bar for click
	accordion.accordions.forEach(function(accord) {
		let btn = accord.querySelector('.accordion-toggle');
		let header = accord.querySelector('.accordion-header-content');

		// Button click event
		btn.addEventListener('click', function() {
			accordion.toggleAccord(btn);
		});

		// Header listener
		if (header) {
			header.addEventListener('click', function() {
				btn.click();
			});
		}
	});
}

// Window Resize
// Size accordions after open
if (accordion.toggleBtns.length) {
	window.addEventListener('resize', function() {
		setTimeout(function() {
			accordion.accordions.forEach(function(item) {
				let accord = item.querySelector('.accordion-body-container'); // Get accordion
				let header = item.querySelector('.accordion-header-container'); // Get accordion
				let bodyClassActive = header.className.indexOf('active') !== -1;
				let content = item.querySelector('.accordion-body-text');
				if (bodyClassActive) {
					let height = content.clientHeight + 40 + 'px';
					accord.style.height = height;
				}
			});
		}, 100);
	});
}
